export function getDateString(offSetDays?: number) {
  const d = new Date()
  if (offSetDays) {
    d.setDate(d.getDate() + offSetDays)
  }
  return d.toISOString()
}
